import React from 'react';

import { getCompanySourceById } from 'shared/companySource';
import { CompanySourceBadge } from 'shared/components/companySource/CompanySourceBadge';

/**
 * @param {number[]} companySources
 * @returns {string}
 */
function getCompanySourcesAriaLabel(companySources) {
    const displayNames = companySources
        .map(getCompanySourceById)
        .filter(Boolean)
        .map((source) => source.displayName);

    if (displayNames.length === 0) return 'Company sources';
    return `Company sources: ${displayNames.join(', ')}`;
}

/**
 * Renders company source badges for a purchase order row.
 *
 * @param {Object} props
 * @param {number[]|null|undefined} [props.companySources] - Company source IDs from the PO row API field.
 * @returns {JSX.Element|null}
 */
export function PoCompanySourcesCell({ companySources = null }) {
    if (!companySources?.length) return null;

    const knownSources = companySources.map(getCompanySourceById).filter(Boolean);
    if (knownSources.length === 0) return null;

    return (
        <span className="inline-flex items-center" aria-label={getCompanySourcesAriaLabel(companySources)} role="img">
            <CompanySourceBadge companySourceIds={companySources} />
        </span>
    );
}
